import styled, { keyframes } from 'styled-components';

const ROTATE = keyframes`
    from {
        transform: rotate(0deg) scaleX(-1);
    }
    to {
        transform: rotate(-360deg) scaleX(-1);
    }
`;

const Spinner = styled.div`
  border-right: 4px solid transparent;
  animation: ${ROTATE} 0.75s linear infinite;
`;

export default Spinner;
